import { Button, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProcessPostPayables extends Layout {
    buttonPostPayables: Button;
    horizontalspacer2: HorizontalSpacer;
    labelPostConfirmation: Label;
    panelCheckCount: Panel;
    panelDirectDepositCount: Panel;
    panelOtherTypesCount: Panel;
    panelTotalCount: Panel;
    panelView: Panel;
    textboxCheckCount: Textbox;
    textboxDirectDepositCount: Textbox;
    textboxOtherTypesCount: Textbox;
    textboxTotalCount: Textbox;
}
